import { render, staticRenderFns } from "./RegistrationsList.vue?vue&type=template&id=92be88fe&"
import script from "./RegistrationsList.vue?vue&type=script&lang=ts&"
export * from "./RegistrationsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports